import passportMonitor from '@/utils/passportMonitor';

class PassportMonitor {
  install(Vue) {
    Vue.prototype.$passportMonitor = passportMonitor;
  }
}

export default new PassportMonitor();
